module.exports = __webpack_public_path__ + "static/img/brilliant-bg2-2x.8c4d31b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brilliant-bg2-2x.jpg
// module id = gZYW
// module chunks = 0